<template>
    <Dialog :visible.sync="showDialog" :style="{ width: '450px' }" :header="header" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <em class="pi pi-exclamation-triangle" style="font-size: 2rem" />
            <span class="ml-3">{{ texto }}</span>
          </div>
          <template #footer>
            <Button label="Sim" icon="pi pi-check"
                class="p-button-text" @click="confirmarDialog"/>
            <Button label="Não" icon="pi pi-times"
                class="p-button-text p-button-danger" @click="cancelarDialog"/>
          </template>
    </Dialog>
</template>

<script>
export default {

  props: {
      onConfirmar: Function,
      onCancelar: Function,
      habilitar: {
        default:false,
      },
      header: {
        default: "Confirmar operação",
      },
      texto: {
        default: "Deseja confirmar a operação?",
      }
  },
  data() {
        return {
          showDialog: false,
        }
  },
  watch: {
    habilitar: function(val) {
        this.showDialog = val;
      },
  },
  methods: {
    hideDialog() {
      this.$emit('update:habilitar', false);
      this.showDialog = false;
    },
    cancelarDialog() {
      if (this.onCancelar) {
        this.onCancelar();
      }
      this.hideDialog();
    },
    confirmarDialog() {
      if (this.onConfirmar) {
        this.onConfirmar();
      }
      this.hideDialog();
    }
  },

}
</script>

<style>
</style>